export const colors = {
    primary: '#003B6F',
    primaryLight: '#5A8FC3',
    primaryDark: '#002D52',
    secondary: '#5A8FC3',
    secondaryLight: '#8BB2D9',
    secondaryDark: '#3A6FA3',

    text: '#0B3B61',
    textSecondary: '#6687A2',
    textMuted: '#8A9BB0',

    background: '#FFFFFF',
    surface: '#F9F9F9',

    background1: '#E9F1FA',
    background2: '#E2E8F0',
    background3: '#F0F2F5',
    background4: '#F4F8FB',

    stroke1: '#CCDEEF',
    stroke2: '#99BCDF',

    button: '#003764',
    buttonHover: '#002a4a',

    link: '#079FF4',
    through: '#009ECF',

    success: '#6FCF97',
    error: '#FE5D7C',
    errorLight: '#FFE7EB',
    warning: '#FF820E',
    warningLight: '#FFF1DC',
    info: '#079FF4',

    footer: 'rgba(3, 39, 76, 1)',

    landingProductsBg: '#F1F6FB',
    landingHowItWorksBg: '#FBF7F1',
    landingRealResultsBg: '#F2F9F8'
} as const
